import RefCardsCarousel from "../refCardsCarousel/refCardsCarousel";
import { useStoryblokGlobalSettings } from "../../hooks/useStoryblokGlobalSettings";
import styles from "./animeSeriesCarousel.module.scss";
import AnimeSeriesCard from "../animeSeriesCard/animeSeriesCard";
import useMediaQuery from "../../hooks/useMediaQuery";
import { FormattedMessage } from "react-intl";
import { useCompressedImage } from "../storyblokImageBasic/helpers";

function AnimeSeriesCarousel({ animeSeries, authorName}) {
  const globalSettings = useStoryblokGlobalSettings();
  const isMobile = useMediaQuery("(max-width: 576px)");
  const { author_anime_series_background_image: desktopBg, author_anime_series_background_mobile: mobileBg } = globalSettings;

  const backgroundImage = useCompressedImage((isMobile? mobileBg : desktopBg)?.filename);

  return (
    <div
      className={styles.root}
      style={{
        backgroundImage: `url(${backgroundImage}), linear-gradient(305.82deg, #213944 11.54%, #2ABDBB 95.62%)`,
        backgroundSize: "cover",
      }}
    >
      <div className={styles.wrapper}>
        <h3 className={styles.authorName}>
          <FormattedMessage id="component.anime_series_carousel.title" values={{ name: authorName }} />
        </h3>
        <RefCardsCarousel
          desktopOptions={{ gap: 45 }}
          tabletOptions={{ gap: 10 }}
          smallTabletOptions={{ gap: 10 }}
          mobileExtendedOptions={{ gap: 10 }}
          extraSmallOptions={{ gap: 10 }}
          withClass={styles.carousel}>
          {animeSeries
            ? animeSeries.map((series) => (
                <AnimeSeriesCard key={series.uuid} series={series} />
              ))
            : []}
        </RefCardsCarousel>
      </div>
    </div>
  );
}

export default AnimeSeriesCarousel;
